import React from 'react';
import Swal from 'sweetalert2';

export const showSweetAlert = (message, classname, iconUrl) => {
    return Swal.fire({
        title: message,
        imageUrl: iconUrl,
        showConfirmButton: false,
        timer: 1000, // Auto-close after 1s
        customClass: {
          popup: classname
        }
    });
  };

  export const showLastSweetAlert = (message, name, iconUrl, navigate, navigatePage) => {    
    return Swal.fire({
        title: message,
        imageUrl: iconUrl,
        showConfirmButton: false,
        timer: 1500, // Auto-close after 1s
        customClass: {
          popup: name
        }
    }).then(() => {
        navigate(navigatePage);
    });
  };

// const removePunctuation = (text) => text.replace(/[.,?!]/g, '');
export const removePunctuation = (text) => {
  return text
    .toLowerCase()
    .replace(/[’']/g, '')    // remove apostrophes ' and ’
    .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?\"]/g, '') // remove other punctuation
    .replace(/\s{2,}/g, ' ') // replace multiple spaces with single
    .trim();
};

const numberAndSymbolMapping = {
  '0': ['zéro'],
  '1': ['un', 'une'],
  '2': ['deux'],
  '3': ['trois'],
  '4': ['quatre'],
  '5': ['cinq'],
  '6': ['six'],
  '7': ['sept'],
  '8': ['huit'],
  '9': ['neuf'],
  '10': ['dix'],
  '11': ['onze'],
  '12': ['douze'],
  '13': ['treize'],
  '14': ['quatorze'],
  '15': ['quinze'],
  '16': ['seize'],
  '17': ['dix-sept', 'dix sept'],
  '18': ['dix-huit', 'dix huit'],
  '19': ['dix-neuf', 'dix neuf'],
  '20': ['vingt'],
  '21': ['vingt-et-un', 'vingt et un'],
  '22': ['vingt-deux', 'vingt deux'],
  '23': ['vingt-trois', 'vingt trois'],
  '24': ['vingt-quatre', 'vingt quatre'],
  '25': ['vingt-cinq', 'vingt cinq'],
  '26': ['vingt-six', 'vingt six'],
  '27': ['vingt-sept', 'vingt sept'],
  '28': ['vingt-huit', 'vingt huit'],
  '29': ['vingt-neuf', 'vingt neuf'],
  '30': ['trente'],
  '31': ['trente-et-un', 'trente et un'],
  '32': ['trente-deux', 'trente deux'],
  '33': ['trente-trois', 'trente trois'],
  '34': ['trente-quatre', 'trente quatre'],
  '35': ['trente-cinq', 'trente cinq'],
  '36': ['trente-six', 'trente six'],
  '37': ['trente-sept', 'trente sept'],
  '38': ['trente-huit', 'trente huit'],
  '39': ['trente-neuf', 'trente neuf'],
  '40': ['quarante'],
  '41': ['quarante-et-un', 'quarante et un'],
  '42': ['quarante-deux', 'quarante deux'],
  '43': ['quarante-trois', 'quarante trois'],
  '44': ['quarante-quatre', 'quarante quatre'],
  '45': ['quarante-cinq', 'quarante cinq'],
  '46': ['quarante-six', 'quarante six'],
  '47': ['quarante-sept', 'quarante sept'],
  '48': ['quarante-huit', 'quarante huit'],
  '49': ['quarante-neuf', 'quarante neuf'],
  '50': ['cinquante'],
  '51': ['cinquante-et-un', 'cinquante et un'],
  '52': ['cinquante-deux', 'cinquante deux'],
  '53': ['cinquante-trois', 'cinquante trois'],
  '54': ['cinquante-quatre', 'cinquante quatre'],
  '55': ['cinquante-cinq', 'cinquante cinq'],
  '56': ['cinquante-six', 'cinquante six'],
  '57': ['cinquante-sept', 'cinquante sept'],
  '58': ['cinquante-huit', 'cinquante huit'],
  '59': ['cinquante-neuf', 'cinquante neuf'],
  '60': ['soixante'],
  '61': ['soixante-et-un', 'soixante et un'],
  '62': ['soixante-deux', 'soixante deux'],
  '63': ['soixante-trois', 'soixante trois'],
  '64': ['soixante-quatre', 'soixante quatre'],
  '65': ['soixante-cinq', 'soixante cinq'],
  '66': ['soixante-six', 'soixante six'],
  '67': ['soixante-sept', 'soixante sept'],
  '68': ['soixante-huit', 'soixante huit'],
  '69': ['soixante-neuf', 'soixante neuf'],
  '70': ['soixante-dix', 'soixante dix'],
  '71': ['soixante-et-onze', 'soixante et onze'],
  '72': ['soixante-douze', 'soixante douze'],
  '73': ['soixante-treize', 'soixante treize'],
  '74': ['soixante-quatorze', 'soixante quatorze'],
  '75': ['soixante-quinze', 'soixante quinze'],
  '76': ['soixante-seize', 'soixante seize'],
  '77': ['soixante-dix-sept', 'soixante dix sept'],
  '78': ['soixante-dix-huit', 'soixante dix huit'],
  '79': ['soixante-dix-neuf', 'soixante dix neuf'],
  '80': ['quatre-vingts', 'quatre vingts'],
  '81': ['quatre-vingt-un', 'quatre vingt un'],
  '82': ['quatre-vingt-deux', 'quatre vingt deux'],
  '83': ['quatre-vingt-trois', 'quatre vingt trois'],
  '84': ['quatre-vingt-quatre', 'quatre vingt quatre'],
  '85': ['quatre-vingt-cinq', 'quatre vingt cinq'],
  '86': ['quatre-vingt-six', 'quatre vingt six'],
  '87': ['quatre-vingt-sept', 'quatre vingt sept'],
  '88': ['quatre-vingt-huit', 'quatre vingt huit'],
  '89': ['quatre-vingt-neuf', 'quatre vingt neuf'],
  '90': ['quatre-vingt-dix', 'quatre vingt dix'],
  '91': ['quatre-vingt-onze', 'quatre vingt onze'],
  '92': ['quatre-vingt-douze', 'quatre vingt douze'],
  '93': ['quatre-vingt-treize', 'quatre vingt treize'],
  '94': ['quatre-vingt-quatorze', 'quatre vingt quatorze'],
  '95': ['quatre-vingt-quinze', 'quatre vingt quinze'],
  '96': ['quatre-vingt-seize', 'quatre vingt seize'],
  '97': ['quatre-vingt-dix-sept', 'quatre vingt dix sept'],
  '98': ['quatre-vingt-dix-huit', 'quatre vingt dix huit'],
  '99': ['quatre-vingt-dix-neuf', 'quatre vingt dix neuf'],
  '100': ['cent'],
  '000': ['mille'],
  '500': ['cinq cent', 'cinq cents'],
  '640': ['six cent quarante', 'six cents quarante'],    
  '1345': ['une virgule trois quatre cinq', 'un virgule trois quatre cinq'], // must remove , because of removepunctuation
  '6725': ['six cent soixante douze virgule cinq', 'six cents soixante douze virgule cinq'], // remove ,
  'ns9204i': ['n s neuf deux zéro quatre i'],
  '4352': ['quatre trois cinq deux'],
  '509': ['cinq cent neuf'],
  '%': ['pour cent'],
  '347841': ['trois quatre sept huit quatre un'],
  '684 976 4312': ['six huit quatre neuf sept six quatre trois un deux'], // remove -
  '379 5136 1284': ['trois sept neuf cinq un trois six un deux huit six'],
  '911': ['neuf un un'],
  'st laurent': ['st laurent', 'saint laurent'],
  'st hubert': ['st hubert', 'saint hubert'],
  'évanoui': ['évanoui', 'évanouie'],
  '250': ['deux virgule cinquante'], // 2,50
  '6h': ['six heures', 'six heure'],
  '22h': ['vingt deux heures', 'vingt deux heure'],
  '120': ['cent vingt'],
  '162': ['un six deux', 'cent soixante deux'],
  '2023': ['deux mille vingt trois'],
  '$': ['dollar', 'dollars'], 
  '6789': ['six sept huit neuf'],
  '12345': ['un deux trois quatre cinq'],
  //purchasing stamps
  '0,75': ['soixante quinze cents', 'soixante-quinze cents'],  
  '4,25': ['quatre dollars vingt cinq', 'quatre dollars vingt-cinq'],
  '0,85': ['quatre vingt cinq cents', 'quatre-vingt-cinq cents'],
  '15,00': ['quinze dollars'],
  '11,50': ['onze dollars cinquante'],	
  '514': ['cinq', 'un', 'quatre'],		
  '731': ['sept trois un'],		
  '8629': ['huit six deux neuf'],		
  '450': ['quatre cinq zéro'],		
  '136': ['un trois six'],		
  '2789': ['deux sept huit neuf'],	
  '692': ['six neuf deux'],		
  '8317': ['huit trois un sept'],		
  '927650': ['neuf deux sept six cinq zéro'],	
  '813': ['huit un trois'],	
  '9726': ['neuf sept deux six'],	
  '5429': ['cinq quatre deux neuf'],		
};

// Generate both hyphenated and space-separated variants for each mapped number phrase
const expandWordWithMapping = (text) => {
  const alternatives = new Set();

  // If the word is a number, map it to its textual representation
  if (numberAndSymbolMapping[text]) {
    numberAndSymbolMapping[text].forEach((alternative) => alternatives.add(alternative));
  }

  // Add the original text
  alternatives.add(text);
  
  return Array.from(alternatives); // Convert to an array for `.some()` checks
};

// Create alternative representations for sentenceB by generating possible sequences
// const generateAlternativeSet = (text) => {
//   const words = text.split(/\s+/);
//   const alternatives = new Set();

//   // Add the original space-separated phrase
//   alternatives.add(words.join(' '));

//   // Add the hyphenated version of the words
//   alternatives.add(words.join('-'));

//   // Add each contiguous phrase sequence
//   for (let i = 0; i < words.length; i++) {
//     for (let j = i + 1; j <= words.length; j++) {
//       alternatives.add(words.slice(i, j).join(' '));
//       alternatives.add(words.slice(i, j).join('-'));
//     }
//   }

//   return alternatives;
// };

export const highlightMatchesUpdatePoint = (sentenceB, sentenceA, onMatch) => {
  
  if (!sentenceA || !sentenceB) return;
  let allCorrect = true;
  
  const wordsA = sentenceA.split(/\s+/);             // Does not convert word to lowercase here to preserve original sentence
  const wordsB = sentenceB.toLowerCase().replace(/-/g, ' ').split(/\s+/); 
  // const wordsB = generateAlternativeSet(removePunctuation(sentenceB.replace(/-/g, ' ').toLowerCase()));
  
  const newFormattedSentence = wordsA.map((word, index) => {
    const isMatch = acceptableAnswer(wordsB, word.toLowerCase());    
    if (isMatch && onMatch) {
      onMatch(); // Call the callback when a match is found
    }
    if (!isMatch && word !== '-') {
      allCorrect = false; // Found an incorrect word
    }
      return (
          <span key={index} style={{ color: (isMatch || word==='-') ? '#00C667' : '#F40000' }}>
              {word + ' '}
          </span>
      );
  });

  return { newFormattedSentence, allCorrect };
};

export const highlightMatchesReport = (sentenceB, sentenceA) => {  
  if (!sentenceA || !sentenceB) return;

  const wordsA = sentenceA.split(/\s+/).flatMap((word) => expandWordWithMapping(removePunctuation(word.toLowerCase())));;
  const wordsB = sentenceB.split(/\s+/);

  return wordsB.map((word, index) => {
      return (
          <span key={index} style={{ color: (acceptableAnswerReport(wordsA, word) || word==='-') ? '#00C667' : '#F40000' }}>
              {word + ' '}
          </span>
      );
  });
};
export const acceptableAnswerReport = (textA, textB) => {
  if (/^[,.?!'"]$/.test(textB)){   
    return true;    //if textA is a standalone ? ! , . ' "
  } 
  // Check if the normalized textB contains textA
  return textA.some((word) => word.includes(removePunctuation(textB.toLowerCase())));
} 

export const highlightMatchesWord = (sentenceB, sentencesA) => {
  if (!sentencesA || !sentenceB) return;  

  const wordsA = sentencesA.split(/\s+/);             // Does not convert word to lowercase here to preserve original sentence
  const wordsB = sentenceB.split(/\s+/);

  for (let word of wordsA) {
    if (!acceptableAnswer(wordsB, word.toLowerCase())) {
      return false; // Return false immediately if any word doesn't match
    }
  }
  return true;
};
export const acceptableAnswer = (textB, textA) => {
  if (/^[,.?!'"]$/.test(textA)){   
    return true;    //if textA is a standalone ? ! , . ' "
  } 

  const textAAlternatives = expandWordWithMapping(removePunctuation(textA));

  // Ensure textB is a string for matching (join if it's an array)
  const cleanedTextB = Array.isArray(textB)
    ? textB.map(removePunctuation).join(' ').toLowerCase()
    : removePunctuation(textB.toLowerCase());

  // Check if any alternative matches with words in `wordsB`
  return textAAlternatives.some(alternative => cleanedTextB.includes(alternative));  
}

// export const getMatchPercentage = (textB, textA) => {
//   if (!textB.trim()) return 0;
//   const wordsB = removePunctuation(textB.toLowerCase()).replace(/-/g, ' ').split(/\s+/);
//   const wordsA = removePunctuation(textA.toLowerCase()).replace(/-/g, ' ').split(/\s+/);
//   const matches = wordsB.filter(word => wordsA.includes(word));
//   return (matches.length / wordsA.length) * 100;
// }

export const getMatchPercentage = (textB, textA) => {
  if (!textB.trim()) return 0;

  const wordsB = removePunctuation(textB.toLowerCase()).replace(/-/g, ' ').split(/\s+/);
  const wordsA = removePunctuation(textA.toLowerCase()).replace(/-/g, ' ').split(/\s+/);

  const expandedWordsSet = new Set();

  for (const wordA of wordsA) {
    if (numberAndSymbolMapping[wordA]) {
      // If it's a number found in the mapping, expand it
      numberAndSymbolMapping[wordA].forEach((alt) => {
        alt.split(/\s+/).forEach(subWord => expandedWordsSet.add(subWord));
      });
    } else {
      // If it's a normal word, keep it as-is
      expandedWordsSet.add(wordA);
    }
  }

  const expandedWords = Array.from(expandedWordsSet);

  let totalMatched = 0;
  for (const requiredWord of expandedWords) {
    if (wordsB.includes(requiredWord)) {
      totalMatched++;
    }
  }

  const totalExpected = expandedWords.length;
  if (totalExpected === 0) return 0;
  return (totalMatched / totalExpected) * 100;
};

export const getPointsEarned = (text, matchPercentage) => {
  if (!text.trim()) return 0;
  const words = removePunctuation(text.toLowerCase()).replace(/-/g, ' ').split(/\s+/);
  return (matchPercentage / 100 * words.length);
}

export const calculateAverageMatch = (userAnswers) => {  //userAnswers here correspond to one conversation
  if (!userAnswers || !Array.isArray(userAnswers.pairs)) {
    return 0; // Return 0 if userAnswers is not valid or doesn't have a pairs array
  }

  let totalMatch = 0;
  let numPairs = 0;

  userAnswers.pairs.forEach(pair => {
      totalMatch += pair.matchPercentage; // Assume matchPercentage is a number
      numPairs++;
  });

  if (numPairs > 0) {
      return (totalMatch / numPairs);
  }
}

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const regexWord = (word) => {
  let normalizedWord = '';
            // MUST MATCH THE ONE IN GETCLASSNAME FUNCTION IN UTILITIS.JS
            if (/\d/.test(word) && word.trim() !== '911,') {// if word contains number
              normalizedWord = word.toLowerCase().replace(/[.?!"]/g, '')
            } else {
              normalizedWord = word.toLowerCase().replace(/[.?,!"]/g, '')
            }
            const escapedWord = normalizedWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special characters in normalizedWord
                  
                  // Build a regular expression to match the exact conditions
                  const regex = new RegExp(`(^|\\s)${escapedWord}(\\s|$)`, 'i');
                  return regex;
}

export const getClassName = (vocabObject, selectedPhrase, word) => {  
  // Normalize the word (remove punctuation, etc.)
  let normalizedWord = '';
  if (/\d/.test(word) && word.trim() !== '911,') {// if word contains number
    normalizedWord = word.toLowerCase().replace(/[.?!"]/g, '')
  } else {
    normalizedWord = word.toLowerCase().replace(/[.?,!"]/g, '')
  }
  
  if (word === '?' || word === '!' || word === '"' || word === '.' || word === ',' || word === '-' )  {
      return 'word'; // Return default class if no vocab entry is found
    }

  // If the word is selected, make the color stronger
  let isSelected;
  if(selectedPhrase.includes(' ')){
    isSelected = selectedPhrase.toLowerCase().includes(normalizedWord);
  } else {
    isSelected = selectedPhrase.toLowerCase() === normalizedWord;
  }  
  const selected = isSelected ? 'selected' : '';

  // Return the final class for the word
  return `word ${selected}`;
};

// export const InstructionBubble = ({ message, name }) => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     if (!sessionStorage.getItem(name)) {
//       setIsVisible(true); // If not shown, make it visible
//       sessionStorage.setItem(name, 'true'); // Set a flag in sessionStorage

//       const timer = setTimeout(() => {
//         setIsVisible(false);
//       }, 2000); // The bubble will disappear after 2 seconds

//       return () => clearTimeout(timer); // Clear the timer if the component unmounts
//     }
//   }, []);

//   if (!isVisible) return null;

//   return (
//     <div className={name}>
//       {message}
//     </div>
//   );
// };

export const frToAudio = (fr, level, topic) => {
  var punctuation = /[.,?!"<>%|/\\*]/g;   //g means remove . , ? ! ' " in whole sentence
  const filename = `/Audio/Conversation/${level}/${topic.replace(punctuation, '')}/${fr.replace(punctuation, '').trim().substring(0,100)}.mp3`;
  return filename;
}

export const frToAudioLesson = (fr, lesson_en, level) => {
  var punctuation = /[:.,?!"<>%|/\\*]/g;   //g means remove . , ? ! ' " in whole sentence
  const filename = `/Audio/Lessons/${level}/${lesson_en.replace(punctuation, '')}/${fr.replace(punctuation, '').trim().substring(0,100)}.mp3`;  
  return filename;
}

export const playWordAudio = (phrase, play, englishTopic) => {
  const processPhrase = phrase.trim();
  let path = '/Audio/Dictionary';

  if (!isNaN(processPhrase[0])) {
    // If the first character is a number, use the Numbers folder
    path += '/Numbers';
  } else if (/[A-Za-z]/.test(processPhrase[0])) {
      // If the first character is a letter, use the folder corresponding to that letter
      path += `/${processPhrase[0].toUpperCase()}`;
  } else {
      // For special cases or any other characters, use the main Dictionary folder
      path += '/Others';
  }

  if (processPhrase === "aux"){    //special case aux.mp3 can't exist
    play(`${path}/aaux.mp3`);
  } else if (processPhrase === "nul"){    //special case nul.mp3 can't exist
    play(`${path}/nnul.mp3`);
  }  else if (processPhrase === "à côté de"){    //special case, can't play mp3 if pass through path
    play(`Audio/Dictionary/Others/à côté de.mp3`);
  } else if (processPhrase === "%"){    
    play(`${path}/pour-cent.mp3`);
  } else if(processPhrase === 'Y'){
    play(`${path}/Y-letter.mp3`);
  } else {
    play(`${path}/${processPhrase.toLowerCase()}.mp3`);
  };
}

export const determineTopicNameFromVerbName = (tense_type_fr, tense_name_fr) => {
  //four indicatif tenses that I did not do
//   plus-que-parfait
// passe simple
// passe anterieur
// futur anterieur
  if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Présent') {
    return 'Le présent';
  } else if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Futur proche') {
    return 'Le futur proche';
  } else if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Passé récent') {
    return 'Le passé récent';
  } else if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Futur simple') {
    return 'Le futur simple';
  } else if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Passé composé') {
    return 'Le passé composé';
  } else if (tense_type_fr === 'Indicatif' && tense_name_fr === 'Imparfait') {
    return 'L’imparfait';
  } else if (tense_type_fr === 'Subjonctif') {
    return 'Le subjonctif';
  } else if (tense_type_fr === 'Conditionnel') {
    return 'Le conditionnel';
  } else if (tense_type_fr === 'Impératif') {
    return 'L’impératif';
  } else {
    return `${tense_type_fr} - ${tense_name_fr}`;
  }
};

export const showPartOfSpeech = (part_of_speech_id, selectedLanguage) => {
  switch (part_of_speech_id) {
    case 1:
      return translations[selectedLanguage].Pronoun; 
    case 2:
      return translations[selectedLanguage].Verb; 
    case 3:
      return translations[selectedLanguage].PronominalVerb;
    case 4:
      return translations[selectedLanguage].Adverb; 
    case 5:
      return translations[selectedLanguage].MasculineAdjective; 
    case 6:
      return translations[selectedLanguage].FeminineAdjective; 
    case 7:
      return translations[selectedLanguage].Adjective; 
    case 8:
      return translations[selectedLanguage].MasculineNoun; 
    case 9:
      return translations[selectedLanguage].FeminineNoun; 
    case 10:
      return translations[selectedLanguage].Noun; 
    case 11:
      return translations[selectedLanguage].Preposition; 
    case 12:
      return translations[selectedLanguage].Conjunction; 
    case 13:
      return translations[selectedLanguage].Article; 
    case 14:
      return translations[selectedLanguage].Determiner; 
    case 15:
      return translations[selectedLanguage].Interjection; 
    case 16:
      return translations[selectedLanguage].PossessiveAdjective; 
    case 17:
      return translations[selectedLanguage].Contraction;  
    case 18:
      return translations[selectedLanguage].Phrase;    
    default:
        return translations[selectedLanguage].OutOfRange; 
  }
}

export const determineIpaPopup = (ipa) => {
  try { 
    // let uniqueSounds = new Set(); 
    let content = '<div class="ipa-list"> ';      
    const chars = ipa.slice(1, -1).split(''); // remove the first and last char then Split the IPA into an array of characters
    const normalChars = ['a', 'ɑ', 'b', 'ɔ', 'd', 'e', 'ə', 'ɛ', 'f', 'ɥ', 'i', 'j', 'ɡ', 'k','n', 'm', 'l', 'ŋ', 'ɲ', 'ø',  'o', 'œ'
      , 'p', 'ʁ', 'ʀ', 's', 'ʃ', 't', 'u', 'v', 'w', 'y', 'z', 'ʒ'
      , 'S', 'Z', 'r', 'G', '.', ' ', '(', ')', '/'];

    for (let i = 0; i < chars.length; i++) {
        let char = chars[i];

        // Check if the next character is a special character that should be grouped
        if (i + 1 < chars.length && !normalChars.includes(chars[i + 1])) {
            char += chars[i + 1]; // Group the current char with the next one
            i++; // Skip the next char since it's already grouped
        }        

        if (char === 'ɡ'){
          content += `<div class="ipa-item"> ${char}  <button class="listen-button" data-audio="/Audio/IPA/k voiced.mp3"> //rename to 'k voiced.mp3' because can't run g.mp3
              <img src="/Icons/listenDictionary.svg" alt={translations[selectedLanguage].Listen}/>
          </button></div>`;
        } else if (char !== '.' && char !== ' ' && char !== '(' && char !== ')' && char !== '/'){// && !uniqueSounds.has(char)){
          // uniqueSounds.add(char);
          content += `<div class="ipa-item"> ${char}  <button class="listen-button" data-audio="/Audio/IPA/${char}.mp3">
                        <img src="/Icons/listenDictionary.svg" alt={translations[selectedLanguage].Listen}/>
                    </button></div>`;
        } else if (char !== '(' && char !== ')' && char !== '/'){
          content += `<br/>`
        }     
    }
    content += ' </div>';
    return content;
  } catch (error) {
    console.error('Error fetching topic content:', error);
  }
};

export const  handleLogin = async () => {    
  window.location.href = "http://localhost:5005/login";   //tried but failed to goback to last page
};
export const handleLogout = (setUser) => {
  setUser(null); // Clear user state
  window.location.href = "http://localhost:5005/logout";  //tried. It goes back to last page but back button does not work properly
};

export const translations = {
  en: {
    next: 'Next',
    back: 'Back',
    start: 'Start',
    summary: 'Summary',
    study: 'Study',    
    Practice: 'Practice',
    PRACTICE: 'PRACTICE',
    pronunciation: 'Pronunciation',
    grammar: 'Grammar',
    chooseALesson: 'Choose a lesson',
    HINT: 'HINT', 
    Option: 'Option', 
    TypeAnswerHere: 'Type your answer here...',
    Write: 'Write',
    Speak: 'Speak',
    YouScore: 'You Score',
    Detected: 'Detected',
    Expected: 'Expected',
    BravoYouFinished: 'Bravo! You just finished',
    Theme: 'Theme',
    Topic: 'Topic',
    PronunciationReport: 'Pronunciation Report',
    GrammarReport: 'Grammar Report',
    PracticeAgain: 'Practice again',
    ReviseThisConversation: 'Revise this conversation',
    ChooseAnotherConversation: 'Choose another conversation',
    DontGiveUp: "Don't give up!",
    YouCanDoIt: "You can do it",
    KeepPracticing: "Keep practicing",
    KeepGoing: "Keep going",
    NotBad: "Not bad",
    GoodJob: "Good job!",
    Bravo: "Bravo!",
    Super: "Super!",
    Excellent: "Excellent!",
    Wow: "Wow!",
    Pro: "What a pro!",
    OutOfRange: "Value is out of range", 
    Menu: 'Menu',
    SearchATopic: 'Search a topic', 
    Home: 'Home', 
    MyVocab: 'My vocabularies', 
    Pronunciation: 'Pronunciation', 
    Grammar: 'Grammar', 
    Profile: 'Profile',
    Search: 'Search',
    collapse: 'collapse',
    expand: 'expand',
    Pause: 'Pause',
    Listen: 'Listen',
    Slow: 'Slow',
    Translation: 'Translation',
    Stop: 'Stop',
    Microphone: 'Microphone',
    Liked: 'Liked',
    Unliked: 'Unliked',
    Logo: 'Logo',
    Transcription: 'Transcription',
    Recording: 'Recording',
    Submit: 'Submit',
    Delete: 'Delete',
    Flag: 'Flag',
    Help: 'Help',
    PleaseChooseAGrammarGroup: 'Please choose a grammar group',    
    PleaseChooseAPronunciationGroup: 'Please choose a pronunciation group',
    PracticeSpeaking: 'Practice speaking',
    PracticeWriting: 'Practice writing',
    TypeHere: 'Type here...',  
    SummaryInstruction: 'These are sentences you will need to practice this conversation. You can click each sentence to learn.',
    PracticeInstruction: 'You will practice speaking with or texting AI. Use this information to complete your task.',
    Situation: 'Situation',
    situationchange: 'Change of situation',
    AI: 'AI',
    SpeakAI: 'Click on speaker to hear',
    UserSpeak: 'Use this information to speak',
    UserWrite: 'Use this information to write',
    Audio: 'Audio: ',
    Listentothissentence: 'Listen to this sentence<br/><br/>',
    SlowLabel: 'Slow: ',
    Adjustaudiospeed: 'Adjust audio speed<br/><br/>',
    TranslationLabel: 'Translation: ',
    Seetranslation: 'See translation<br/><br/>',
    MicrophoneLabel: 'Microphone: ',
    Readthissentence: 'Read this sentence and receive instant feedback.<br/><br/>If this button does not work, go to your phone Settings -> your browser -> Microphone -> Ask<br/><br/>',
    Expandablesentence: 'Expandable sentences: ',
    Clickthissentencetolearn: 'Click each sentence to learn<br/><br/>',
    PracticeLabel: 'Practice: ',
    Practicewhenyouareready: 'Practice when you are ready<br/><br/>',
    changeLabel: 'change: ',
    changeSituation: 'Choose another situation<br/><br/>',
    SituationLabel: 'Situation: ',
    collapseSituationDescription: 'Show or hide the situation description<br/><br/>',
    TranscriptionLabel: 'Transcription: ',
    Seetranscription: 'See transcription<br/><br/>',
    Options: 'Options: ',
    possibleAnswers: 'These are possible answers.<br/><br/>',
    Recordyouranswers: 'Record your answers<br/><br/>',
    inputarea: 'Typing area: ',
    Writeyouranswers: 'Type your answers<br/><br/>',
    Contraction: 'Contraction',
    Masculine: 'Masculine',
    Feminine: 'Feminine',
    Plural: 'Plural',
    Pronoun: 'Pronoun',
    Verb: 'Verb',
    PronominalVerb: 'Pronominal Verb',
    Adverb: 'Adverb',
    MasculineAdjective: 'Masculine Adjective',
    FeminineAdjective: 'Feminine Adjective',
    Adjective: 'Adjective',
    MasculineNoun: 'Masculine Noun',
    FeminineNoun: 'Feminine Noun',
    Noun: 'Noun',
    Preposition: 'Preposition',
    Conjunction: 'Conjunction',
    Article: 'Article',
    Determiner: 'Determiner',
    Interjection: 'Interjection',
    PossessiveAdjective: 'Possessive Adjective',
    studySpeak: 'Study - Speaking',
    studyListen: 'Study - Listening',
    NoviceProgram: 'Novice program',
    GeneralProgramEasy: 'General program - easy',
    GeneralProgram: 'General program',
    GrammarTopic: 'Grammar topic: ',
    Note: 'Note: ', 
    Phrase: 'Phrase',
    FeedbackSent: 'Feedback submitted successfully!',
    FeedbackNotSent: 'Failed to submit feedback. Our apology. Please send your feedback to info@aiducare.com',
    SpeakLouder: 'Please speak louder',
    InstructionVideo: 'Instructional video',
    Doesnotsupportvideo: 'Your browser does not support the video tag',
    WordLabel: 'Text: ',
    Clickonword: 'Click on individual words to study',
    GiveFeedback: 'Feedback about our demo',
    Level: 'Level',
    PleaseChooseALevel: 'Please choose a level',
    Conversations: 'Conversations',
    Lessons: 'Lessons',
    lessonInstruction: 'Instruction',
    lessonSpeak: 'Lesson - Speaking',
    lessonListen: 'Lesson - Listening',
    LessonsConversations: 'Lessons & Conversations',
    situationDescription: 'Description of your task',
    PointsColon: 'Points: ',
    Points: 'Points',
    YourPoints: 'Your points: ',
    MyReports: 'My reports',
    Filters: 'Filters',
    Datapreferences: 'Data preferences',    
    Date: 'Date',
    Fromdate: 'From date',
    Todate: 'To date',
    Skills: 'Skills',
    Speaking: 'Speaking',
    Writing: 'Writing',
    Levels: 'Levels',
    Reset: 'Reset',
    WeeklyProgress: 'Weekly progress',
    DefaultIsMonthly: 'Default setting: monthly',
    AverageScore: 'Average Score',
    Skill: 'Skill',
    Score: 'Score',
    Login: 'Login',
    Logout: 'Logout',
    MyProfile: 'My profile',
    AccountID: 'Account ID',
    Email: 'Email',
    ChangePassword: 'Change Password',
    Subscriptions: 'Subscriptions',
    PaymentInfo: 'Payment Info',
    OrderHistory: 'Order History',
    Save: 'Save',
    EnterFirstName: 'Please enter first name',
    EnterLastName: 'Please enter last name',
    UsernameUpdated: 'Username has been updated',
    Name: 'Name',
    FirstName: 'First Name',
    LastName: 'Last Name',
    ChooseAnotherConversation: 'Choose another conversation',
LessonsConversations: 'Lessons & Conversations',
Conversation: 'Conversation',
NEXTLESSON: 'NEXT LESSON',
PRACTICECONVERSATION: 'PRACTICE CONVERSATION',
NEXTLESSONLEVEL2: 'NEXT LESSON - LEVEL 2',
NEXTLEVEL: 'NEXT LEVEL',
chooseATopic: 'Choose a topic',
ConversationInstruction: 'Note that on the study page <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />, the first half of the sentences focus on speaking practice, while the second half focus on listening.',
NoVocabYet: 'No vocabularies added yet.',
  },
  fr: {
    next: 'Suivant',
    back: 'Retour',
    start: 'Commencer',
    summary: 'Résumé',
    study: 'Étudier',
    Practice: 'Pratiquer',
    PRACTICE: 'PRATIQUER',
    pronunciation: 'Prononciation',
    grammar: 'Grammaire',
    chooseALesson: 'Choisissez une leçon',
    HINT: 'INDICE', 
    Option: 'Option', 
    TypeAnswerHere: 'Tapez votre réponse ici...',
    Write: 'Écrire',
    Speak: 'Parler',
    YouScore: 'Votre Score',
    Detected: 'Détecté',
    Expected: 'Attendu',
    BravoYouFinished: 'Bravo! Vous avez terminé',
    Theme: 'Thème',
    Topic: 'Sujet',
    PronunciationReport: 'Rapport de Prononciation',
    GrammarReport: 'Rapport de Grammaire',
    PracticeAgain: 'Pratiquer à nouveau',
    ReviseThisConversation: 'Réviser cette conversation',
    ChooseAnotherTopic: 'Choisissez un autre sujet',
    DontGiveUp: "Ne lâche pas!",
    YouCanDoIt: "Tu peux le faire",
    KeepPracticing: "Continue à pratiquer",
    KeepGoing: "Continue",
    NotBad: "Pas mal",
    GoodJob: "Bon travail!",
    Bravo: "Bravo!",
    Super: "Super!",
    Excellent: "Excellent!",
    Wow: "Wow!",
    Pro: "Quel pro!",
    OutOfRange: "Valeur hors limites",
    Menu: 'Menu',
    SearchATopic: 'Rechercher un sujet', 
    Home: 'Accueil', 
    MyVocab: 'Mes vocabulaires', 
    Pronunciation: 'Prononciation', 
    Grammar: 'Grammaire', 
    Profile: 'Profil',
    Search: 'Rechercher',
    collapse: 'réduire',
    expand: 'développer',
    Pause: 'Pause',
    Listen: 'Écouter',
    Slow: 'Lent',
    Translation: 'Traduction',
    Stop: 'Arrêter',
    Microphone: 'Microphone',
    Liked: 'Aimé',
    Unliked: 'Non aimé',
    Logo: 'Logo',
    Transcription: 'Transcription',
    Recording: 'Enregistrement',
    Submit: 'Soumettre',
    Delete: 'Supprimer',
    Flag: 'Drapeau',   
    Help: 'Aide',
    PleaseChooseATheme: 'Veuillez choisir un thème',
    PleaseChooseAGrammarGroup: 'Veuillez choisir un groupe de grammaire',
    PleaseChooseAPronunciationGroup: 'Veuillez choisir un groupe de prononciation',
    PracticeSpeaking: 'Pratiquer la parole',
    PracticeWriting: 'Pratiquer l\'écriture',
    TypeHere: 'Tapez ici...',
    SummaryInstruction: 'Voici des phrases dont vous aurez besoin pour pratiquer cette conversation. Vous pouvez cliquer sur chaque phrase pour apprendre.',
    PracticeInstruction: 'Vous allez pratiquer en parlant avec ou en envoyant des messages à l’IA. Utilisez ces informations pour accomplir votre tâche.',
    Situation: 'Situation',
    situationchange: 'Changement de situation',
    AI: 'IA',
    SpeakAI: 'Cliquez sur le haut-parleur pour écouter',
    UserSpeak: 'Utilisez ces informations pour parler',
    UserWrite: 'Utilisez ces informations pour écrire',
    Audio: 'Audio : ',
    Listentothissentence: 'Écoutez cette phrase<br/><br/>',
    SlowLabel: 'Lent : ',
    Adjustaudiospeed: 'Ajuster la vitesse de l\'audio<br/><br/>',
    TranslationLabel: 'Traduction : ',
    Seetranslation: 'Voir la traduction<br/><br/>',
    MicrophoneLabel: 'Microphone : ',
    Readthissentence: 'Lisez cette phrase et recevez des commentaires instantanés.<br/><br/>Si ce bouton ne fonctionne pas, allez dans les paramètres de votre téléphone -> votre navigateur -> Microphone -> Demander<br/><br/>',
    Expandablesentence: 'Phrases extensibles : ',
    Clickthissentencetolearn: 'Cliquez sur chaque phrase pour apprendre<br/><br/>',
    PracticeLabel: 'Pratique : ',
    Practicewhenyouareready: 'Pratiquez quand vous êtes prêt<br/><br/>',
    changeLabel: 'changer : ',
    changeSituation: 'Choisissez une autre situation<br/><br/>',
    SituationLabel: 'Situation : ',
    collapseSituationDescription: 'Afficher ou masquer la description de la situation<br/><br/>',
    TranscriptionLabel: 'Transcription : ',
    Seetranscription: 'Voir la transcription<br/><br/>',
    Options: 'Options : ',
    possibleAnswers: 'Voici des réponses possibles.<br/><br/>',
    Recordyouranswers: 'Enregistrez vos réponses<br/><br/>',
    inputarea: 'Zone de saisie : ',
    Writeyouranswers: 'Tapez vos réponses<br/><br/>',
    Contraction: 'Contraction',
    Masculine: 'Masculin',
    Feminine: 'Féminin',
    Plural: 'Pluriel',
    Pronoun: 'Pronom',
    Verb: 'Verbe',
    PronominalVerb: 'Verbe pronominal',
    Adverb: 'Adverbe',
    MasculineAdjective: 'Adjectif masculin',
    FeminineAdjective: 'Adjectif féminin',
    Adjective: 'Adjectif',
    MasculineNoun: 'Nom masculin',
    FeminineNoun: 'Nom féminin',
    Noun: 'Nom',
    Preposition: 'Préposition',
    Conjunction: 'Conjonction',
    Article: 'Article',
    Determiner: 'Déterminant',
    Interjection: 'Interjection',
    PossessiveAdjective: 'Adjectif possessif' ,
    studySpeak: 'Étudier - Parler',
    studyListen: 'Étudier - Écouter',
    NoviceProgram: 'Programme novice',
GeneralProgramEasy: 'Programme général - facile',
GeneralProgram: 'Programme général',
GrammarTopic: 'Sujet de grammaire : ',
Note: 'Remarque : ',
Phrase: 'Phrase',
FeedbackSent: 'Commentaire envoyé avec succès !',
FeedbackNotSent: 'Échec de l\'envoi des commentaires. Nous nous excusons. Veuillez envoyer vos commentaires à info@aiducare.com',
SpeakLouder: 'Veuillez parler plus fort',
InstructionVideo: 'Vidéo d\'instruction',
Doesnotsupportvideo: 'Votre navigateur ne prend pas en charge la balise vidéo',
WordLabel: 'Texte : ',
Clickonword: 'Cliquez sur les mots individuels pour étudier',
GiveFeedback: 'Retour d\'expérience sur notre démo',
Level: 'Niveau',
PleaseChooseALevel: 'Veuillez choisir un niveau',
Conversations: 'Conversations',
Lessons: 'Leçons',
lessonInstruction: 'Instruction',
lessonSpeak: 'Leçon - Expression orale',
lessonListen: 'Leçon - Écoute',
situationDescription: 'Description de votre tâche',
PointsColon: 'Points : ',
Points: 'Points',
YourPoints: 'Vos points : ',
MyReports: 'Mes rapports',
Filters: 'Filtres',
Datapreferences: 'Préférences de données',    
Date: 'Date',
Fromdate: 'Date de début',
Todate: 'Date de fin',
Skills: 'Compétences',
Speaking: 'Parler',
Writing: 'Écrire',
Levels: 'Niveaux',
Reset: 'Réinitialiser',
WeeklyProgress: 'Progrès hebdomadaire',
DefaultIsMonthly: 'Paramètre par défaut : mensuel',
AverageScore: 'Score moyen',
Skill: 'Compétence',
Score: 'Score',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'Mon profil',
AccountID: 'Identifiant de compte',
Email: 'Email',
ChangePassword: 'Changer le mot de passe',
Subscriptions: 'Abonnements',
PaymentInfo: 'Informations de paiement',
OrderHistory: 'Historique des commandes',
Save: 'Enregistrer',
EnterFirstName: 'Veuillez entrer le prénom',
EnterLastName: 'Veuillez entrer le nom de famille',
UsernameUpdated: 'Le nom d\'utilisateur a été mis à jour',
Name: 'Nom',
FirstName: 'Prénom',
LastName: 'Nom de famille',
ChooseAnotherConversation: 'Choisissez une autre conversation',
LessonsConversations: 'Leçons & Conversations',
Conversation: 'Conversation',
NEXTLESSON: 'LEÇON SUIVANTE',
PRACTICECONVERSATION: 'PRATIQUER LA CONVERSATION',
NEXTLESSONLEVEL2: 'PROCHAINE LEÇON - NIVEAU 2',
NEXTLEVEL: 'NIVEAU SUIVANT'  ,
chooseATopic: 'Choisissez un sujet',
ConversationInstruction: 'Notez que sur la page d\'étude <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />, la première moitié des phrases se concentre sur la pratique orale, tandis que la seconde moitié se concentre sur l\'écoute.',
NoVocabYet: 'Aucun vocabulaire ajouté pour le moment.',
  },
  es: {
    chooseATopic: 'Elige un tema',
    next: 'Siguiente',
    back: 'Atrás',
    start: 'Empezar',
    summary: 'Resumen',
    study: 'Estudiar',
    Practice: 'Practicar',
    PRACTICE: 'PRACTICAR',
    pronunciation: 'Pronunciación',
    grammar: 'Gramática',
    chooseALesson: 'Elige una lección',
    HINT: 'PISTA', 
    Option: 'Opción', 
    TypeAnswerHere: 'Escribe tu respuesta aquí...',
    Write: 'Escribir',
    Speak: 'Hablar',
    YouScore: 'Tu Puntuación',
    Detected: 'Detectado',
    Expected: 'Esperado',
    BravoYouFinished: '¡Bravo! Has terminado',
    Theme: 'Tema',
    Topic: 'Tópico',
    PronunciationReport: 'Informe de Pronunciación',
    GrammarReport: 'Informe de Gramática',
    PracticeAgain: 'Practicar de nuevo',
    ReviseThisConversation: 'Revisa esta conversación',
    ChooseAnotherTopic: 'Elige otro tema',
    DontGiveUp: "¡No te rindas!",
    YouCanDoIt: "Tú puedes hacerlo",
    KeepPracticing: "Sigue practicando",
    KeepGoing: "Sigue adelante",
    NotBad: "No está mal",
    GoodJob: "¡Buen trabajo!",
    Bravo: "¡Bravo!",
    Super: "¡Súper!",
    Excellent: "¡Excelente!",
    Wow: "¡Guau!",
    Pro: "¡Qué profesional!",
    OutOfRange: "Valor fuera de rango",
    Menu: 'Menú',
    SearchATopic: 'Buscar un tema', 
    Home: 'Inicio', 
    MyVocab: 'Mis vocabularios', 
    Pronunciation: 'Pronunciación', 
    Grammar: 'Gramática', 
    Profile: 'Perfil',
    Search: 'Buscar',
    collapse: 'colapsar',
    expand: 'expandir',
    Pause: 'Pausa',
    Listen: 'Escuchar',
    Slow: 'Lento',
    Translation: 'Traducción',
    Stop: 'Detener',
    Microphone: 'Micrófono',
    Liked: 'Me gusta',
    Unliked: 'No me gusta',
    Logo: 'Logo',
    Transcription: 'Transcripción',
    Recording: 'Grabación',
    Submit: 'Enviar',
    Delete: 'Eliminar',
    Flag: 'Bandera',   
    Help: 'Ayuda',
    PleaseChooseAGrammarGroup: 'Por favor elige un grupo de gramática',
    PleaseChooseAPronunciationGroup: 'Por favor elige un grupo de pronunciación',
    PracticeSpeaking: 'Practicar hablar',
    PracticeWriting: 'Practicar escribir',
    TypeHere: 'Escribe aquí...',
    SummaryInstruction: 'Estas son las frases que necesitarás para practicar esta conversación. Puedes hacer clic en cada frase para aprender.',
    PracticeInstruction: 'Practicarás hablando con la IA o enviándole mensajes. Usa esta información para completar tu tarea.',
    Situation: 'Situación',
    situationchange: 'Cambio de situación',
    AI: 'IA',
    SpeakAI: 'Haz clic en el altavoz para escuchar',
    UserSpeak: 'Use esta información para hablar',  
    UserWrite: 'Use esta información para escribir',
    Audio: 'Audio: ',
    Listentothissentence: 'Escucha esta oración<br/><br/>',
    SlowLabel: 'Lento: ',
    Adjustaudiospeed: 'Ajustar velocidad de audio<br/><br/>',
    TranslationLabel: 'Traducción: ',
    Seetranslation: 'Ver traducción<br/><br/>',
    MicrophoneLabel: 'Micrófono: ',
    Readthissentence: 'Lee esta oración y recibe retroalimentación instantánea.<br/><br/>Si este botón no funciona, ve a Configuración de tu teléfono -> tu navegador -> Micrófono -> Preguntar<br/><br/>',
    Expandablesentence: 'Oraciones expandibles: ',
    Clickthissentencetolearn: 'Haz clic en cada oración para aprender<br/><br/>',
    PracticeLabel: 'Práctica: ',
    Practicewhenyouareready: 'Practica cuando estés listo<br/><br/>',
    changeLabel: 'cambiar: ',
    changeSituation: 'Elige otra situación<br/><br/>',
    SituationLabel: 'Situación: ',
    collapseSituationDescription: 'Mostrar u ocultar la descripción de la situación<br/><br/>',
    TranscriptionLabel: 'Transcripción: ',
    Seetranscription: 'Ver transcripción<br/><br/>',
    Options: 'Opciones: ',
    possibleAnswers: 'Estas son posibles respuestas.<br/><br/>',
    Recordyouranswers: 'Graba tus respuestas<br/><br/>',
    inputarea: 'Área de escritura: ',
    Writeyouranswers: 'Escribe tus respuestas<br/><br/>'  ,  
    Contraction: 'Contracción',
    Masculine: 'Masculino',
    Feminine: 'Femenino',
    Plural: 'Plural',
    Pronoun: 'Pronombre',
    Verb: 'Verbo',
    PronominalVerb: 'Verbo pronominal',
    Adverb: 'Adverbio',
    MasculineAdjective: 'Adjetivo masculino',
    FeminineAdjective: 'Adjetivo femenino',
    Adjective: 'Adjetivo',
    MasculineNoun: 'Sustantivo masculino',
    FeminineNoun: 'Sustantivo femenino',
    Noun: 'Sustantivo',
    Preposition: 'Preposición',
    Conjunction: 'Conjunción',
    Article: 'Artículo',
    Determiner: 'Determinante',
    Interjection: 'Interjección',
    PossessiveAdjective: 'Adjetivo posesivo'  ,
    studySpeak: 'Estudiar - Hablar', 
    studyListen: 'Estudiar - Escuchar',
    NoviceProgram: 'Programa principiante',
GeneralProgramEasy: 'Programa general - fácil',
GeneralProgram: 'Programa general',
GrammarTopic: 'Tema de gramática: ',
Note: 'Nota: ',
Phrase: 'Frase',
FeedbackSent: '¡Comentarios enviados con éxito!',
FeedbackNotSent: 'Error al enviar los comentarios. Lo sentimos. Por favor, envíe sus comentarios a info@aiducare.com',
SpeakLouder: 'Por favor, hable más alto',
InstructionVideo: 'Video instructivo',
    Doesnotsupportvideo: 'Su navegador no soporta la etiqueta de video',
    WordLabel: 'Texto: ',
    Clickonword: 'Haz clic en palabras individuales para estudiar',
    GiveFeedback: 'Comentarios sobre nuestra demostración',
    Level: 'Nivel',
    PleaseChooseALevel: 'Por favor elige un nivel',
    Conversations: 'Conversaciones',
Lessons: 'Lecciones',
lessonInstruction: 'Instrucción',
lessonSpeak: 'Lección - Hablar',
lessonListen: 'Lección - Escuchar',
situationDescription: 'Descripción de tu tarea',
PointsColon: 'Puntos: ',
Points: 'Puntos',
YourPoints: 'Tus puntos: ',
MyReports: 'Mis informes',
Filters: 'Filtros',
Datapreferences: 'Preferencias de datos',    
Date: 'Fecha',
Fromdate: 'Desde la fecha',
Todate: 'Hasta la fecha',
Skills: 'Habilidades',
Speaking: 'Hablar',
Writing: 'Escribir',
Levels: 'Niveles',
Reset: 'Restablecer',
WeeklyProgress: 'Progreso semanal',
DefaultIsMonthly: 'Configuración predeterminada: mensual',
AverageScore: 'Puntuación promedio',
Skill: 'Habilidad',
Score: 'Puntuación',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'Mi perfil',
AccountID: 'ID de cuenta',
Email: 'Correo electrónico',
ChangePassword: 'Cambiar la contraseña',
Subscriptions: 'Suscripciones',
PaymentInfo: 'Información de pago',
OrderHistory: 'Historial de pedidos',
Save: 'Guardar',
EnterFirstName: 'Por favor, ingrese el nombre',
EnterLastName: 'Por favor, ingrese el apellido',
UsernameUpdated: 'El nombre de usuario ha sido actualizado',
Name: 'Nombre',
FirstName: 'Nombre',
LastName: 'Apellido',
ChooseAnotherConversation: 'Elige otra conversación',
LessonsConversations: 'Lecciones & Conversaciones',
Conversation: 'Conversación',
NEXTLESSON: 'PRÓXIMA LECCIÓN',
PRACTICECONVERSATION: 'PRACTICAR CONVERSACIÓN',
NEXTLESSONLEVEL2: 'PRÓXIMA LECCIÓN - NIVEL 2',
NEXTLEVEL: 'SIGUIENTE NIVEL' ,
ConversationInstruction: 'Tenga en cuenta que en la página de estudio <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />, la primera mitad de las oraciones se centra en la práctica del habla, mientras que la segunda mitad se centra en la escucha.',
NoVocabYet: 'Aún no se han agregado vocabularios.',
  },
  pt_br: {
    next: 'Avançar',
back: 'Voltar',
start: 'Iniciar',
summary: 'Resumo',
study: 'Estudar',
Practice: 'Praticar',
PRACTICE: 'PRATICAR',
pronunciation: 'Pronúncia',
grammar: 'Gramática',
chooseATheme: 'Escolha um tema',
chooseATopic: 'Escolha um tópico',
chooseALesson: 'Escolha uma lição',
HINT: 'DICA',
Option: 'Opção',
TypeAnswerHere: 'Digite sua resposta aqui...',
Write: 'Escrever',
Speak: 'Falar',
YouScore: 'Sua pontuação',
Detected: 'Detectado',
Expected: 'Esperado',
BravoYouFinished: 'Parabéns! Você terminou',
Theme: 'Tema',
Topic: 'Tópico',
PronunciationReport: 'Relatório de pronúncia',
GrammarReport: 'Relatório de gramática',
PracticeAgain: 'Praticar novamente',
ReviseThisConversation: 'Revisar esta conversa',
ChooseAnotherTopic: 'Escolher outro tópico',
DontGiveUp: 'Não desista!',
YouCanDoIt: 'Você consegue!',
KeepPracticing: 'Continue praticando',
KeepGoing: 'Continue',
NotBad: 'Nada mal',
GoodJob: 'Bom trabalho!',
Bravo: 'Parabéns!',
Super: 'Super!',
Excellent: 'Excelente!',
Wow: 'Uau!',
Pro: 'Que profissional!',
OutOfRange: 'Valor fora do intervalo',
Menu: 'Menu',
SearchATopic: 'Buscar um tópico',
Home: 'Início',
MyVocab: 'Meus vocabulários',
Pronunciation: 'Pronúncia',
Grammar: 'Gramática',
Profile: 'Perfil',
Search: 'Pesquisar',
collapse: 'Recolher',
expand: 'Expandir',
Pause: 'Pausar',
Listen: 'Ouvir',
Slow: 'Lento',
Translation: 'Tradução',
Stop: 'Parar',
Microphone: 'Microfone',
Liked: 'Gostado',
Unliked: 'Não gostado',
Logo: 'Logo',
Transcription: 'Transcrição',
Recording: 'Gravação',
Submit: 'Enviar',
Delete: 'Excluir',
Flag: 'Bandeira',
Help: 'Ajuda',
PleaseChooseATheme: 'Por favor, escolha um tema',
PleaseChooseAGrammarGroup: 'Por favor, escolha um grupo de gramática',
PleaseChooseAPronunciationGroup: 'Por favor, escolha um grupo de pronúncia',
PracticeSpeaking: 'Praticar falar',
PracticeWriting: 'Praticar escrever',
TypeHere: 'Digite aqui...',
SummaryInstruction: 'Estas são as frases que você precisará para praticar esta conversa. Você pode clicar em cada frase para aprender.',
PracticeInstruction: 'Você praticará falando ou enviando mensagens para a IA. Use essas informações para concluir sua tarefa.',
Situation: 'Situação',
situationchange: 'Mudança de situação',
AI: 'IA',
SpeakAI: 'Clique no alto-falante para ouvir',
UserSpeak: 'Use esta informação para falar',  
    UserWrite: 'Use esta informação para escrever',
Audio: 'Áudio:',
Listentothissentence: 'Ouça esta frase<br/><br/>',
SlowLabel: 'Lento:',
Adjustaudiospeed: 'Ajustar a velocidade do áudio<br/><br/>',
TranslationLabel: 'Tradução:',
Seetranslation: 'Ver tradução<br/><br/>',
MicrophoneLabel: 'Microfone:',
Readthissentence: 'Leia esta frase e receba feedback instantâneo.<br/><br/>Se este botão não funcionar, vá para Configurações do seu telefone -> seu navegador -> Microfone -> Permitir.<br/><br/>',
Expandablesentence: 'Frases expansíveis:',
Clickthissentencetolearn: 'Clique em cada frase para aprender<br/><br/>',
PracticeLabel: 'Prática:',
Practicewhenyouareready: 'Pratique quando estiver pronto<br/><br/>',
changeLabel: 'Alterar:',
changeSituation: 'Escolha outra situação<br/><br/>',
SituationLabel: 'Situação:',
collapseSituationDescription: 'Mostrar ou ocultar a descrição da situação<br/><br/>',
TranscriptionLabel: 'Transcrição:',
Seetranscription: 'Ver transcrição<br/><br/>',
Options: 'Opções:',
possibleAnswers: 'Estas são respostas possíveis.<br/><br/>',
Recordyouranswers: 'Grave suas respostas<br/><br/>',
inputarea: 'Área de digitação:',
Writeyouranswers: 'Digite suas respostas<br/><br/>',
Contraction: 'Contração',
Masculine: 'Masculino',
Feminine: 'Feminino',
Plural: 'Plural',
Pronoun: 'Pronome',
Verb: 'Verbo',
PronominalVerb: 'Verbo pronominal',
Adverb: 'Advérbio',
MasculineAdjective: 'Adjetivo masculino',
FeminineAdjective: 'Adjetivo feminino',
Adjective: 'Adjetivo',
MasculineNoun: 'Substantivo masculino',
FeminineNoun: 'Substantivo feminino',
Noun: 'Substantivo',
Preposition: 'Preposição',
Conjunction: 'Conjunção',
Article: 'Artigo',
Determiner: 'Determinante',
Interjection: 'Interjeição',
PossessiveAdjective: 'Adjetivo possessivo',
studySpeak: 'Estudo - Falar',
studyListen: 'Estudo - Ouvir',
NoviceProgram: 'Programa iniciante',
GeneralProgramEasy: 'Programa geral - fácil',
GeneralProgram: 'Programa geral',
GrammarTopic: 'Tópico de gramática:',
Note: 'Nota:',
Phrase: 'Frase',
FeedbackSent: 'Feedback enviado com sucesso!',
FeedbackNotSent: 'Falha ao enviar feedback. Pedimos desculpas. Por favor, envie seu feedback para info@aiducare.com',
SpeakLouder: 'Por favor, fale mais alto',
InstructionVideo: 'Vídeo instrucional',
Doesnotsupportvideo: 'Seu navegador não suporta a tag de vídeo',
WordLabel: 'Texto:',
Clickonword: 'Clique em palavras individuais para estudar',
GiveFeedback: 'Feedback sobre nossa demonstração',
Level: 'Nível',
PleaseChooseALevel: 'Por favor, escolha um nível',
Conversations: 'Conversas',
Lessons: 'Lições',
lessonInstruction: 'Instrução',
lessonSpeak: 'Lição - Falar',
lessonListen: 'Lição - Ouvir',
situationDescription: 'Descrição da sua tarefa',
PointsColon: 'Pontos: ',
Points: 'Pontos',
YourPoints: 'Seus pontos: ',
MyReports: 'Meus relatórios',
Filters: 'Filtros',
Datapreferences: 'Preferências de dados',    
Date: 'Data',
Fromdate: 'Data inicial',
Todate: 'Data final',
Skills: 'Habilidades',
Speaking: 'Falar',
Writing: 'Escrever',
Levels: 'Níveis',
Reset: 'Redefinir',
WeeklyProgress: 'Progresso semanal',
DefaultIsMonthly: 'Configuração padrão: mensal',
AverageScore: 'Pontuação média',
Skill: 'Habilidade',
Score: 'Pontuação',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'Meu perfil',
AccountID: 'ID da conta',
Email: 'Email',
ChangePassword: 'Alterar senha',
Subscriptions: 'Assinaturas',
PaymentInfo: 'Informações de pagamento',
OrderHistory: 'Histórico de pedidos',
Save: 'Salvar',
EnterFirstName: 'Por favor, insira o primeiro nome',
EnterLastName: 'Por favor, insira o sobrenome',
UsernameUpdated: 'O nome de usuário foi atualizado',
Name: 'Nome',
FirstName: 'Primeiro nome',
LastName: 'Sobrenome',
ChooseAnotherConversation: 'Escolha outra conversa',
LessonsConversations: 'Lições & Conversas',
Conversation: 'Conversa',
NEXTLESSON: 'PRÓXIMA LIÇÃO',
PRACTICECONVERSATION: 'PRATICAR CONVERSAÇÃO',
NEXTLESSONLEVEL2: 'PRÓXIMA LIÇÃO - NÍVEL 2',
NEXTLEVEL: 'PRÓXIMO NÍVEL'  ,
ConversationInstruction: 'Note que na página de estudo <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />, a primeira metade das frases se concentra na prática da fala, enquanto a segunda metade se concentra na audição.',
NoVocabYet: 'Nenhum vocabulário adicionado ainda.',
  },
  ar: {
    next: 'التالي',
    back: 'العودة',
    start: 'ابدأ',
    summary: 'الملخص',
    study: 'دراسة',
    Practice: 'ممارسة',
    PRACTICE: 'ممارسة',
    pronunciation: 'النطق',
    grammar: 'القواعد',
    chooseATheme: 'اختر موضوعًا',
    chooseATopic: 'اختر موضوعًا',
    chooseALesson: 'اختر درسًا',
    HINT: 'تلميح', 
    Option: 'خيار', 
    TypeAnswerHere: 'اكتب إجابتك هنا',
    Write: 'اكتب',
    Speak: 'تحدث',
    YouScore: 'درجتك',
    Detected: 'تم الكشف',
    Expected: 'متوقع',
    BravoYouFinished: 'برافو! لقد أنهيت',
    Theme: 'موضوع',
    Topic: 'عنوان',
    PronunciationReport: 'تقرير النطق',
    GrammarReport: 'تقرير القواعد',
    PracticeAgain: 'تمرن مرة أخرى',
    ReviseThisConversation: 'راجع هذه المحادثة',
    ChooseAnotherTopic: 'اختر موضوعًا آخر',
    DontGiveUp: "لا تستسلم!",
    YouCanDoIt: "أنت تستطيع",
    KeepPracticing: "واصل التدرب",
    KeepGoing: "استمر",
    NotBad: "ليس سيئًا",
    GoodJob: "عمل جيد!",
    Bravo: "برافو!",
    Super: "ممتاز!",
    Excellent: "ممتاز!",
    Wow: "رائع!",
    Pro: "يا له من محترف!",
    OutOfRange: "القيمة خارج النطاق",
    Menu: 'قائمة',
    SearchATopic: 'البحث عن موضوع', 
    Home: 'الصفحة الرئيسية', 
    MyVocab: 'مفرداتي', 
    Pronunciation: 'النطق', 
    Grammar: 'القواعد', 
    Profile: 'الملف الشخصي',
    Search: 'بحث',
    collapse: 'طي',
    expand: 'توسيع',
    Pause: 'إيقاف مؤقت',
    Listen: 'استمع',
    Slow: 'بطيء',
    Translation: 'ترجمة',
    Stop: 'توقف',
    Microphone: 'ميكروفون',
    Liked: 'أعجبني',
    Unliked: 'لم يعجبني',
    Logo: 'شعار',
    Transcription: 'نسخ',
    Recording: 'تسجيل',
    Submit: 'إرسال',
    Delete: 'حذف',
    Flag: 'علم',    
    Help: 'مساعدة',
    PleaseChooseATheme: 'يرجى اختيار موضوع',
    PleaseChooseAGrammarGroup: 'يرجى اختيار مجموعة قواعد',
    PleaseChooseAPronunciationGroup: 'يرجى اختيار مجموعة نطق',
    PracticeSpeaking: 'التدرب على الكلام',
    PracticeWriting: 'التدرب على الكتابة',
    TypeHere: 'اكتب هنا...',
    SummaryInstruction: 'هذه هي الجمل التي ستحتاج إلى استخدامها لممارسة هذه المحادثة. يمكنك النقر على كل جملة للتعلم.',
    PracticeInstruction: 'سوف تمارس التحدث مع الذكاء الاصطناعي أو إرسال الرسائل النصية إليه. استخدم هذه المعلومات لإكمال مهمتك.',
    Situation: 'الوضع',
    situationchange: 'تغيير الحالة',
    AI: 'الذكاء الاصطناعي',
    SpeakAI: 'انقر على مكبر الصوت للاستماع',
    UserSpeak: 'استخدم هذه المعلومات للتحدث',  
    UserWrite: 'استخدم هذه المعلومات للكتابة',
    Audio: 'الصوت: ',
    Listentothissentence: 'استمع إلى هذه الجملة<br/><br/>',
    SlowLabel: 'بطيء: ',
    Adjustaudiospeed: 'تعديل سرعة الصوت<br/><br/>',
    TranslationLabel: 'الترجمة: ',
    Seetranslation: 'عرض الترجمة<br/><br/>',
    MicrophoneLabel: 'الميكروفون: ',
    Readthissentence: 'اقرأ هذه الجملة وتلقى ردود فعل فورية.<br/><br/>إذا لم يعمل هذا الزر، انتقل إلى إعدادات هاتفك -> المتصفح -> ميكروفون -> طلب<br/><br/>',
    Expandablesentence: 'جمل قابلة للتوسيع: ',
    Clickthissentencetolearn: 'انقر على كل جملة للتعلم<br/><br/>',
    PracticeLabel: 'التدريب: ',
    Practicewhenyouareready: 'تدرب عندما تكون مستعدًا<br/><br/>',
    changeLabel: 'تغيير: ',
    changeSituation: 'اختر وضعًا آخر<br/><br/>',
    SituationLabel: 'الوضع: ',
    collapseSituationDescription: 'إظهار أو إخفاء وصف الوضع<br/><br/>',
    TranscriptionLabel: 'النص المكتوب: ',
    Seetranscription: 'عرض النص المكتوب<br/><br/>',
    Options: 'خيارات: ',
    possibleAnswers: 'هذه إجابات ممكنة.<br/><br/>',
    Recordyouranswers: 'سجل إجاباتك<br/><br/>',
    inputarea: 'منطقة الكتابة: ',
    Writeyouranswers: 'اكتب إجاباتك<br/><br/>',
    Contraction: 'اختصار',
    Masculine: 'مذكر',
    Feminine: 'مؤنث',
    Plural: 'جمع',
    Pronoun: 'ضمير',
    Verb: 'فعل',
    PronominalVerb: 'فعل انعكاسي',
    Adverb: 'حال',
    MasculineAdjective: 'صفة مذكرة',
    FeminineAdjective: 'صفة مؤنثة',
    Adjective: 'صفة',
    MasculineNoun: 'اسم مذكر',
    FeminineNoun: 'اسم مؤنث',
    Noun: 'اسم',
    Preposition: 'حرف جر',
    Conjunction: 'أداة ربط',
    Article: 'أداة تعريف',
    Determiner: 'محدد',
    Interjection: 'صيحة',
    PossessiveAdjective: 'صفة ملكية',
    studySpeak: 'الدراسة - التحدث', studyListen: 'الدراسة - الاستماع',
    NoviceProgram: 'برنامج المبتدئين',
GeneralProgramEasy: 'برنامج عام - سهل',
GeneralProgram: 'برنامج عام',
GrammarTopic: 'موضوع القواعد: ',
Note: 'ملاحظة: ',
Phrase: 'عبارة',
FeedbackSent: 'تم إرسال التعليقات بنجاح!',
FeedbackNotSent: 'فشل في إرسال التعليقات. نحن نعتذر. يرجى إرسال تعليقاتك إلى info@aiducare.com',
SpeakLouder: 'من فضلك تكلم بصوت أعلى',
InstructionVideo: 'فيديو تعليمي',
    Doesnotsupportvideo: 'متصفحك لا يدعم وسم الفيديو',
    WordLabel: 'النص: ',
    Clickonword: 'انقر على الكلمات الفردية للدراسة',
    GiveFeedback: 'ملاحظات حول عرضنا التوضيحي',
    Level: 'مستوى',
    PleaseChooseALevel: 'يرجى اختيار مستوى',
    Conversations: 'المحادثات',
Lessons: 'الدروس',
lessonInstruction: 'التعليمات',
lessonSpeak: 'الدرس - التحدث',
lessonListen: 'الدرس - الاستماع',
situationDescription: 'وصف مهمتك',
PointsColon: 'النقاط: ',
Points: 'النقاط',
YourPoints: 'نقاطك: ',
MyReports: 'تقاريري',
Filters: 'مرشحات',
Datapreferences: 'تفضيلات البيانات',    
Date: 'التاريخ',
Fromdate: 'من التاريخ',
Todate: 'إلى التاريخ',
Skills: 'المهارات',
Speaking: 'التحدث',
Writing: 'الكتابة',
Levels: 'المستويات',
Reset: 'إعادة تعيين',
WeeklyProgress: 'التقدم الأسبوعي',
DefaultIsMonthly: 'الإعداد الافتراضي: شهري',
AverageScore: 'المعدل المتوسط',
Skill: 'المهارة',
Score: 'الدرجة',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'ملفي الشخصي',
AccountID: 'معرّف الحساب',
Email: 'البريد الإلكتروني',
ChangePassword: 'تغيير كلمة المرور',
Subscriptions: 'الاشتراكات',
PaymentInfo: 'معلومات الدفع',
OrderHistory: 'سجل الطلبات',
Save: 'حفظ',
EnterFirstName: 'يرجى إدخال الاسم الأول',
EnterLastName: 'يرجى إدخال اسم العائلة',
UsernameUpdated: 'تم تحديث اسم المستخدم',
Name: 'الاسم',
FirstName: 'الاسم الأول',
LastName: 'اسم العائلة',
ChooseAnotherConversation: 'اختر محادثة أخرى',
LessonsConversations: 'الدروس والمحادثات',
Conversation: 'محادثة',
NEXTLESSON: 'الدرس التالي',
PRACTICECONVERSATION: 'ممارسة المحادثة',
NEXTLESSONLEVEL2: 'الدرس التالي - المستوى 2',
NEXTLEVEL: 'المستوى التالي'  ,
ConversationInstruction: 'لاحظ أنه في صفحة الدراسة <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />، تركز النصف الأول من الجمل على ممارسة التحدث، بينما يركز النصف الثاني على الاستماع.',
NoVocabYet: 'لم يتم إضافة أي مفردات بعد.',
  },
  fa: {
    next: 'بعدی',
    back: 'بازگشت',
    start: 'شروع',
    summary: 'خلاصه',
    study: 'مطالعه',
    Practice: 'تمرین',
    PRACTICE: 'تمرین',
    pronunciation: 'تلفظ',
    grammar: 'دستور زبان',
    chooseATheme: 'انتخاب یک موضوع',
    chooseATopic: 'انتخاب یک مبحث',
    chooseALesson: 'یک درس انتخاب کنید',
    HINT: 'راهنمایی', 
    Option: 'گزینه', 
    TypeAnswerHere: 'پاسخ خود را اینجا بنویسید',
    Write: 'نوشتن',
    Speak: 'صحبت کردن',
    YouScore: 'امتیاز شما',
    Detected: 'تشخیص داده شد',
    Expected: 'انتظار می رفت',
    BravoYouFinished: 'آفرین! شما تمام کردید',
    Theme: 'موضوع',
    Topic: 'عنوان',
    PronunciationReport: 'گزارش تلفظ',
    GrammarReport: 'گزارش دستور زبان',
    PracticeAgain: 'دوباره تمرین کن',
    ReviseThisConversation: 'این مکالمه را مرور کنید',
    ChooseAnotherTopic: 'موضوع دیگری را انتخاب کنید',
    DontGiveUp: "تسلیم نشو!",
    YouCanDoIt: "تو می‌توانی",
    KeepPracticing: "ادامه بده",
    KeepGoing: "ادامه بده",
    NotBad: "بد نیست",
    GoodJob: "کارت عالی بود!",
    Bravo: "آفرین!",
    Super: "عالی!",
    Excellent: "عالی!",
    Wow: "وای!",
    Pro: "چه حرفه‌ای!",
    OutOfRange: "مقدار خارج از محدوده است",
    Menu: 'منو',
    SearchATopic: 'جستجوی یک موضوع', 
    Home: 'خانه', 
    MyVocab: 'واژگان من', 
    Pronunciation: 'تلفظ', 
    Grammar: 'دستور زبان', 
    Profile: 'پروفایل',
    Search: 'جستجو',
    collapse: 'جمع کردن',
    expand: 'گسترش دادن',
    Pause: 'توقف',
    Listen: 'گوش دادن',
    Slow: 'آهسته',
    Translation: 'ترجمه',
    Stop: 'توقف',
    Microphone: 'میکروفون',
    Liked: 'پسندیده شد',
    Unliked: 'پسندیده نشد',
    Logo: 'لوگو',
    Transcription: 'رونوشت',
    Recording: 'ضبط',
    Submit: 'ارسال',
    Delete: 'حذف',
    Flag: 'پرچم',   
    Help: 'کمک',
    PleaseChooseATheme: 'لطفاً یک موضوع انتخاب کنید',
    PleaseChooseAGrammarGroup: 'لطفاً یک گروه گرامر انتخاب کنید',
    PleaseChooseAPronunciationGroup: 'لطفاً یک گروه تلفظ انتخاب کنید',
    PracticeSpeaking: 'تمرین صحبت کردن',
    PracticeWriting: 'تمرین نوشتن',
    TypeHere: 'اینجا تایپ کنید...',
    SummaryInstruction: 'این‌ها جملاتی هستند که برای تمرین این مکالمه به آن‌ها نیاز دارید. می‌توانید روی هر جمله کلیک کنید تا یاد بگیرید.',
    PracticeInstruction: 'شما تمرین صحبت کردن یا ارسال پیام با هوش مصنوعی را انجام خواهید داد. از این اطلاعات برای تکمیل وظیفه خود استفاده کنید.',
    Situation: 'وضعیت',
    situationchange: 'تغییر وضعیت',
    AI: 'هوش مصنوعی',
    SpeakAI: 'برای شنیدن روی بلندگو کلیک کنید',
    UserSpeak: 'از این اطلاعات برای صحبت کردن استفاده کنید',  
    UserWrite: 'از این اطلاعات برای نوشتن استفاده کنید',
    Audio: 'صدا: ',
    Listentothissentence: 'به این جمله گوش دهید<br/><br/>',
    SlowLabel: 'آهسته: ',
    Adjustaudiospeed: 'تنظیم سرعت صدا<br/><br/>',
    TranslationLabel: 'ترجمه: ',
    Seetranslation: 'مشاهده ترجمه<br/><br/>',
    MicrophoneLabel: 'میکروفون: ',
    Readthissentence: 'این جمله را بخوانید و بازخورد فوری دریافت کنید.<br/><br/>اگر این دکمه کار نمی‌کند، به تنظیمات تلفن خود بروید -> مرورگر خود -> میکروفون -> درخواست<br/><br/>',
    Expandablesentence: 'جملات گسترش‌پذیر: ',
    Clickthissentencetolearn: 'برای یادگیری روی هر جمله کلیک کنید<br/><br/>',
    PracticeLabel: 'تمرین: ',
    Practicewhenyouareready: 'وقتی آماده شدید تمرین کنید<br/><br/>',
    changeLabel: 'تغییر: ',
    changeSituation: 'وضعیت دیگری را انتخاب کنید<br/><br/>',
    SituationLabel: 'وضعیت: ',
    collapseSituationDescription: 'نمایش یا پنهان کردن توضیحات وضعیت<br/><br/>',
    TranscriptionLabel: 'رونویسی: ',
    Seetranscription: 'مشاهده رونویسی<br/><br/>',
    Options: 'گزینه‌ها: ',
    possibleAnswers: 'این‌ها پاسخ‌های احتمالی هستند.<br/><br/>',
    Recordyouranswers: 'پاسخ‌های خود را ضبط کنید<br/><br/>',
    inputarea: 'منطقه نوشتاری: ',
    Writeyouranswers: 'پاسخ‌های خود را تایپ کنید<br/><br/>'   ,
    Contraction: 'انقباض',
    Masculine: 'مذکر',
    Feminine: 'مونث',
    Plural: 'جمع',
    Pronoun: 'ضمیر',
    Verb: 'فعل',
    PronominalVerb: 'فعل انعکاسی',
    Adverb: 'قید',
    MasculineAdjective: 'صفت مذکر',
    FeminineAdjective: 'صفت مونث',
    Adjective: 'صفت',
    MasculineNoun: 'اسم مذکر',
    FeminineNoun: 'اسم مونث',
    Noun: 'اسم',
    Preposition: 'حرف اضافه',
    Conjunction: 'حرف ربط',
    Article: 'حرف تعریف',
    Determiner: 'معرفه',
    Interjection: 'حرف ندا',
    PossessiveAdjective: 'صفت ملکی'   ,
    studySpeak: 'مطالعه - صحبت کردن', studyListen: 'مطالعه - گوش دادن',
    NoviceProgram: 'برنامه مبتدی',
GeneralProgramEasy: 'برنامه عمومی - آسان',
GeneralProgram: 'برنامه عمومی',
GrammarTopic: 'موضوع دستور زبان: ',
Note: 'توجه: ',
Phrase: 'عبارت',
FeedbackSent: 'بازخورد با موفقیت ارسال شد!',
FeedbackNotSent: 'ارسال بازخورد با شکست مواجه شد. پوزش می‌خواهیم. لطفاً بازخورد خود را به info@aiducare.com ارسال کنید',
SpeakLouder: 'لطفاً بلندتر صحبت کنید',
InstructionVideo: 'ویدئوی آموزشی',
    Doesnotsupportvideo: 'مرورگر شما از تگ ویدئو پشتیبانی نمی‌کند',
    WordLabel: 'متن: ',
    Clickonword: 'روی کلمات جداگانه کلیک کنید تا مطالعه کنید',
    GiveFeedback: 'بازخورد درباره نسخه نمایشی ما',
    Level: 'سطح',
    PleaseChooseALevel: 'لطفاً یک سطح را انتخاب کنید',
    Conversations: 'گفتگوها',
Lessons: 'درس‌ها',
lessonInstruction: 'دستورالعمل',
lessonSpeak: 'درس - مکالمه',
lessonListen: 'درس - شنیدن',
situationDescription: 'توضیح وظیفه شما',
PointsColon: 'امتیازات: ',
Points: 'امتیازات',
YourPoints: 'امتیازات شما: ',
MyReports: 'گزارش‌های من',
Filters: 'فیلترها',
Datapreferences: 'ترجیحات داده',    
Date: 'تاریخ',
Fromdate: 'از تاریخ',
Todate: 'تا تاریخ',
Skills: 'مهارت‌ها',
Speaking: 'صحبت کردن',
Writing: 'نوشتن',
Levels: 'سطوح',
Reset: 'بازنشانی',
WeeklyProgress: 'پیشرفت هفتگی',
DefaultIsMonthly: 'تنظیم پیش‌فرض: ماهانه',
AverageScore: 'میانگین امتیاز',
Skill: 'مهارت',
Score: 'امتیاز',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'پروفایل من',
AccountID: 'شناسه حساب',
Email: 'ایمیل',
ChangePassword: 'تغییر رمز عبور',
Subscriptions: 'اشتراک‌ها',
PaymentInfo: 'اطلاعات پرداخت',
OrderHistory: 'تاریخچه سفارشات',
Save: 'ذخیره',
EnterFirstName: 'لطفاً نام کوچک را وارد کنید',
EnterLastName: 'لطفاً نام خانوادگی را وارد کنید',
UsernameUpdated: 'نام کاربری به‌روزرسانی شد',
Name: 'نام',
FirstName: 'نام کوچک',
LastName: 'نام خانوادگی',
ChooseAnotherConversation: 'یک مکالمه دیگر را انتخاب کنید',
LessonsConversations: 'درس‌ها و مکالمات',
Conversation: 'مکالمه',
NEXTLESSON: 'درس بعدی',
PRACTICECONVERSATION: 'تمرین مکالمه',
NEXTLESSONLEVEL2: 'درس بعدی - سطح 2',
NEXTLEVEL: 'سطح بعدی'  ,
ConversationInstruction: 'توجه داشته باشید که در صفحه مطالعه <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />، نیمه اول جملات بر تمرین صحبت کردن تمرکز دارد، در حالی که نیمه دوم بر گوش دادن تمرکز دارد.',
NoVocabYet: 'هنوز واژگانی اضافه نشده است.',
  },
  zh: {
    next: '下一步',
    back: '返回',
    start: '开始',
    summary: '总结',
    study: '学习',
    Practice: '练习',
    PRACTICE: '练习',
    pronunciation: '发音',
    grammar: '语法',
    chooseATheme: '选择一个主题',
    chooseATopic: '选择一个话题',
    chooseALesson: '选择一节课',
    HINT: '提示', 
    Option: '选项', 
    TypeAnswerHere: '在这里输入你的答案...',
    Write: '写',
    Speak: '说',
    YouScore: '你的得分',
    Detected: '检测到',
    Expected: '预期',
    BravoYouFinished: '太棒了！你刚刚完成了',
    Theme: '主题',
    Topic: '话题',
    PronunciationReport: '发音报告',
    GrammarReport: '语法报告',
    PracticeAgain: '再练习一次',
    ReviseThisConversation: '复习这段对话',
    ChooseAnotherTopic: '选择另一个话题',
    DontGiveUp: "不要放弃!",
    YouCanDoIt: "你可以的",
    KeepPracticing: "继续练习",
    KeepGoing: "继续",
    NotBad: "不错",
    GoodJob: "干得好!",
    Bravo: "太棒了!",
    Super: "超级棒!",
    Excellent: "优秀!",
    Wow: "哇!",
    Pro: "真是高手!",
    OutOfRange: "数值超出范围",
    Menu: '指数',
    SearchATopic: '搜索主题', 
    Home: '首页', 
    MyVocab: '我的词汇表', 
    Pronunciation: '发音', 
    Grammar: '语法', 
    Profile: '个人资料',
    Search: '搜索',
    collapse: '折叠',
    expand: '展开',
    Pause: '暂停',
    Listen: '听',
    Slow: '慢',
    Translation: '翻译',
    Stop: '停止',
    Microphone: '麦克风',
    Liked: '喜欢',
    Unliked: '不喜欢',
    Logo: '标志',
    Transcription: '转录',
    Recording: '录音',
    Submit: '提交',
    Delete: '删除',
    Flag: '旗帜',    
    Help: '帮助',
    PleaseChooseATheme: '请选择一个主题',
    PleaseChooseAGrammarGroup: '请选择一个语法组',
    PleaseChooseAPronunciationGroup: '请选择一个发音组',
    PracticeSpeaking: '练习说话',
    PracticeWriting: '练习写作',
    TypeHere: '在这里输入...',
    SummaryInstruction: '这些是你练习这段对话所需的句子。你可以点击每个句子来学习。',
    PracticeInstruction: '你将练习与 AI 交谈或发送消息。使用这些信息完成你的任务。',
    Situation: '情景',
    situationchange: '情况变化',
    AI: '人工智能',
    SpeakAI: '点击扬声器收听',
    UserSpeak: '使用这些信息来说话',  
    UserWrite: '使用这些信息来写作',
    Audio: '音频：',
    Listentothissentence: '听这句话<br/><br/>',
    SlowLabel: '慢速：',
    Adjustaudiospeed: '调整音频速度<br/><br/>',
    TranslationLabel: '翻译：',
    Seetranslation: '查看翻译<br/><br/>',
    MicrophoneLabel: '麦克风：',
    Readthissentence: '读这句话并获得即时反馈。<br/><br/>如果此按钮不起作用，请转到手机设置 -> 浏览器 -> 麦克风 -> 请求<br/><br/>',
    Expandablesentence: '可扩展句子：',
    Clickthissentencetolearn: '点击每个句子进行学习<br/><br/>',
    PracticeLabel: '练习：',
    Practicewhenyouareready: '准备好时进行练习<br/><br/>',
    changeLabel: '更改：',
    changeSituation: '选择另一种情况<br/><br/>',
    SituationLabel: '情景：',
    collapseSituationDescription: '显示或隐藏情景描述<br/><br/>',
    TranscriptionLabel: '转录：',
    Seetranscription: '查看转录<br/><br/>',
    Options: '选项：',
    possibleAnswers: '这些是可能的答案。<br/><br/>',
    Recordyouranswers: '记录您的答案<br/><br/>',
    inputarea: '输入区：',
    Writeyouranswers: '输入您的答案<br/><br/>',
    Contraction: '缩写',
    Masculine: '阳性',
    Feminine: '阴性',
    Plural: '复数',
    Pronoun: '代词',
    Verb: '动词',
    PronominalVerb: '代词动词',
    Adverb: '副词',
    MasculineAdjective: '阳性形容词',
    FeminineAdjective: '阴性形容词',
    Adjective: '形容词',
    MasculineNoun: '阳性名词',
    FeminineNoun: '阴性名词',
    Noun: '名词',
    Preposition: '介词',
    Conjunction: '连词',
    Article: '冠词',
    Determiner: '限定词',
    Interjection: '感叹词',
    PossessiveAdjective: '所有格形容词',
    studySpeak: '学习 - 口语', studyListen: '学习 - 听力',
    NoviceProgram: '初学者计划',
GeneralProgramEasy: '通用计划 - 简单',
GeneralProgram: '通用计划',
GrammarTopic: '语法主题：',
Note: '注意：',
Phrase: '短语',
FeedbackSent: '反馈已成功提交！',
FeedbackNotSent: '提交反馈失败。我们深表歉意。请将您的反馈发送至 info@aiducare.com',
SpeakLouder: '请大声点说',
InstructionVideo: '教学视频',
    Doesnotsupportvideo: '您的浏览器不支持视频标签',
    WordLabel: '文本：',
    Clickonword: '点击单个单词进行学习',
    GiveFeedback: '关于我们演示的反馈',
    Level: '等级',
    PleaseChooseALevel: '请选择一个等级',
    Conversations: '对话',
Lessons: '课程',
lessonInstruction: '指导',
lessonSpeak: '课程 - 口语',
lessonListen: '课程 - 听力',
situationDescription: '任务描述',
PointsColon: '分数: ',
Points: '分数',
YourPoints: '您的分数: ',
MyReports: '我的报告',
Filters: '筛选器',
Datapreferences: '数据偏好',    
Date: '日期',
Fromdate: '开始日期',
Todate: '结束日期',
Skills: '技能',
Speaking: '口语',
Writing: '写作',
Levels: '等级',
Reset: '重置',
WeeklyProgress: '每周进度',
DefaultIsMonthly: '默认设置：每月',
AverageScore: '平均分',
Skill: '技能',
Score: '分数',
Login: 'Login',
Logout: 'Logout',
MyProfile: '我的个人资料',
AccountID: '账户 ID',
Email: '电子邮件',
ChangePassword: '更改密码',
Subscriptions: '订阅',
PaymentInfo: '付款信息',
OrderHistory: '订单历史',
Save: '保存',
EnterFirstName: '请输入名字',
EnterLastName: '请输入姓氏',
UsernameUpdated: '用户名已更新',
Name: '姓名',
FirstName: '名字',
LastName: '姓氏',
ChooseAnotherConversation: '选择另一场对话',
LessonsConversations: '课程与对话',
Conversation: '对话',
NEXTLESSON: '下一课',
PRACTICECONVERSATION: '练习对话',
NEXTLESSONLEVEL2: '下一课 - 第2级',
NEXTLEVEL: '下一级'  ,
ConversationInstruction: '请注意，在学习页面 <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />，前半部分的句子侧重于口语练习，而后半部分侧重于听力。',
NoVocabYet: '尚未添加词汇。',
  },
  vi: {
    next: 'Tiếp theo',
    back: 'Quay lại',
    start: 'Bắt đầu',
    summary: 'Tóm tắt',
    study: 'Học tập',
    Practice: 'Luyện tập',
    PRACTICE: 'LUYỆN TẬP',
    pronunciation: 'Phát âm',
    grammar: 'Ngữ pháp',
    chooseATheme: 'Chọn đề tài',
    chooseATopic: 'Chọn chủ đề',
    chooseALesson: 'Chọn một bài học',
    HINT: 'GỢI Ý', 
    Option: 'Lựa chọn', 
    TypeAnswerHere: 'Nhập câu trả lời của bạn tại đây...',
    Write: 'Viết',
    Speak: 'Nói',
    YouScore: 'Điểm của bạn',
    Detected: 'Đã phát hiện',
    Expected: 'Mong đợi',
    BravoYouFinished: 'Hoan hô! Bạn đã hoàn thành',
    Theme: 'Đề tài',
    Topic: 'Chủ đề',
    PronunciationReport: 'Báo cáo Phát âm',
    GrammarReport: 'Báo cáo Ngữ pháp',
    PracticeAgain: 'Luyện tập lại',
    ReviseThisConversation: 'Xem lại hội thoại này',
    ChooseAnotherTopic: 'Chọn chủ đề khác',
    DontGiveUp: "Đừng bỏ cuộc!",
    YouCanDoIt: "Bạn có thể làm được",
    KeepPracticing: "Tiếp tục luyện tập",
    KeepGoing: "Tiếp tục",
    NotBad: "Không tệ",
    GoodJob: "Làm tốt lắm!",
    Bravo: "Tuyệt vời!",
    Super: "Siêu!",
    Excellent: "Xuất sắc!",
    Wow: "Wow!",
    Pro: "Bạn thật chuyên nghiệp!",
    OutOfRange: "Giá trị vượt quá phạm vi",
    Menu: 'Mục lục',
    SearchATopic: 'Tìm kiếm một chủ đề', 
    Home: 'Trang chủ', 
    MyVocab: 'Từ vựng của tôi', 
    Pronunciation: 'Phát âm', 
    Grammar: 'Ngữ pháp', 
    Profile: 'Hồ sơ',
    Search: 'Tìm kiếm',
    collapse: 'thu gọn',
    expand: 'mở rộng',
    Pause: 'Tạm dừng',
    Listen: 'Nghe',
    Slow: 'Chậm',
    Translation: 'Dịch',
    Stop: 'Dừng',
    Microphone: 'Micro',
    Liked: 'Đã thích',
    Unliked: 'Không thích',
    Logo: 'Logo',
    Transcription: 'Phiên âm',
    Recording: 'Ghi âm',
    Submit: 'Gửi',
    Delete: 'Xóa',
    Flag: 'Cờ',   
    Help: 'Trợ giúp',
    PleaseChooseATheme: 'Vui lòng chọn một chủ đề',
    PleaseChooseAGrammarGroup: 'Vui lòng chọn một nhóm ngữ pháp',
    PleaseChooseAPronunciationGroup: 'Vui lòng chọn một nhóm phát âm',
    PracticeSpeaking: 'Luyện nói',
    PracticeWriting: 'Luyện viết',
    TypeHere: 'Nhập ở đây...',
    SummaryInstruction: 'Đây là những câu bạn cần để luyện tập hội thoại này. Bạn có thể ấn vào từng câu để học.',
    PracticeInstruction: 'Bạn sẽ luyện nói hoặc nhắn tin với AI. Sử dụng thông tin này để hoàn thành nhiệm vụ của bạn.',
    Situation: 'Tình huống',
    situationchange: 'Thay đổi tình huống',
    AI: 'AI',
    SpeakAI: 'Nhấp vào loa để nghe',
    UserSpeak: 'Sử dụng thông tin này để nói',  
    UserWrite: 'Sử dụng thông tin này để viết',
    Audio: 'Âm thanh: ',
    Listentothissentence: 'Nghe câu này<br/><br/>',
    SlowLabel: 'Chậm: ',
    Adjustaudiospeed: 'Điều chỉnh tốc độ âm thanh<br/><br/>',
    TranslationLabel: 'Dịch: ',
    Seetranslation: 'Xem bản dịch<br/><br/>',
    MicrophoneLabel: 'Micrô: ',
    Readthissentence: 'Đọc câu này và nhận phản hồi ngay lập tức.<br/><br/>Nếu nút này không hoạt động, hãy vào Cài đặt điện thoại của bạn -> trình duyệt của bạn -> Micrô -> Yêu cầu<br/><br/>',
    Expandablesentence: 'Câu có thể mở rộng: ',
    Clickthissentencetolearn: 'Nhấp vào từng câu để học<br/><br/>',
    PracticeLabel: 'Luyện tập: ',
    Practicewhenyouareready: 'Luyện tập khi bạn sẵn sàng<br/><br/>',
    changeLabel: 'thay đổi: ',
    changeSituation: 'Chọn một tình huống khác<br/><br/>',
    SituationLabel: 'Tình huống: ',
    collapseSituationDescription: 'Hiển thị hoặc ẩn mô tả tình huống<br/><br/>',
    TranscriptionLabel: 'Chép lại: ',
    Seetranscription: 'Xem bản chép lại<br/><br/>',
    Options: 'Tùy chọn: ',
    possibleAnswers: 'Đây là các câu trả lời có thể.<br/><br/>',
    Recordyouranswers: 'Ghi lại câu trả lời của bạn<br/><br/>',
    inputarea: 'Khu vực nhập: ',
    Writeyouranswers: 'Nhập câu trả lời của bạn<br/><br/>',
    Contraction: 'Rút gọn',
    Masculine: 'Giống đực',
    Feminine: 'Giống cái',
    Plural: 'Số nhiều',
    Pronoun: 'Đại từ',
    Verb: 'Động từ',
    PronominalVerb: 'Động từ đại từ',
    Adverb: 'Trạng từ',
    MasculineAdjective: 'Tính từ giống đực',
    FeminineAdjective: 'Tính từ giống cái',
    Adjective: 'Tính từ',
    MasculineNoun: 'Danh từ giống đực',
    FeminineNoun: 'Danh từ giống cái',
    Noun: 'Danh từ',
    Preposition: 'Giới từ',
    Conjunction: 'Liên từ',
    Article: 'Mạo từ',
    Determiner: 'Từ hạn định',
    Interjection: 'Thán từ',
    PossessiveAdjective: 'Tính từ sở hữu'  ,
    studySpeak: 'Học - Nói', 
    studyListen: 'Học - Nghe',
    NoviceProgram: 'Chương trình người mới',
GeneralProgramEasy: 'Chương trình chung - dễ',
GeneralProgram: 'Chương trình chung',
GrammarTopic: 'Chủ đề ngữ pháp: ',
Note: 'Lưu ý: ',
Phrase: 'Cụm từ',
FeedbackSent: 'Phản hồi đã được gửi thành công!',
FeedbackNotSent: 'Gửi phản hồi không thành công. Chúng tôi xin lỗi. Vui lòng gửi phản hồi của bạn đến info@aiducare.com',
SpeakLouder: 'Làm ơn nói lớn hơn',
InstructionVideo: 'Video hướng dẫn',
    Doesnotsupportvideo: 'Trình duyệt của bạn không hỗ trợ video',
    WordLabel: 'Văn bản: ',
    Clickonword: 'Nhấp vào từng từ để học',
    GiveFeedback: 'Phản hồi về demo của chúng tôi',
    Level: 'Cấp độ',
    PleaseChooseALevel: 'Vui lòng chọn một cấp độ',
    Conversations: 'Hội thoại',
Lessons: 'Bài học',
lessonInstruction: 'Hướng dẫn',
lessonSpeak: 'Bài học - Nói',
lessonListen: 'Bài học - Nghe',
situationDescription: 'Mô tả nhiệm vụ của bạn',
PointsColon: 'Điểm: ',
Points: 'Điểm',
YourPoints: 'Điểm của bạn: ',
MyReports: 'Báo cáo của tôi',
Filters: 'Bộ lọc',
Datapreferences: 'Tùy chọn dữ liệu',    
Date: 'Ngày',
Fromdate: 'Từ ngày',
Todate: 'Đến ngày',
Skills: 'Kỹ năng',
Speaking: 'Nói',
Writing: 'Viết',
Levels: 'Cấp độ',
Reset: 'Đặt lại',
WeeklyProgress: 'Tiến độ hàng tuần',
DefaultIsMonthly: 'Mặc định: hàng tháng',
AverageScore: 'Điểm trung bình',
Skill: 'Kỹ năng',
Score: 'Điểm số',
Login: 'Login',
Logout: 'Logout',
MyProfile: 'Hồ sơ của tôi',
AccountID: 'ID tài khoản',
Email: 'Email',
ChangePassword: 'Đổi mật khẩu',
Subscriptions: 'Gói đăng ký',
PaymentInfo: 'Thông tin thanh toán',
OrderHistory: 'Lịch sử đặt hàng',
Save: 'Lưu',
EnterFirstName: 'Vui lòng nhập tên',
EnterLastName: 'Vui lòng nhập họ',
UsernameUpdated: 'Tên người dùng đã được cập nhật',
Name: 'Tên',
FirstName: 'Tên',
LastName: 'Họ',
ChooseAnotherConversation: 'Chọn hội thoại khác',
LessonsConversations: 'Bài học & Hội thoại',
Conversation: 'Hội thoại',
NEXTLESSON: 'BÀI HỌC TIẾP THEO',
PRACTICECONVERSATION: 'LUYỆN TẬP HỘI THOẠI',
NEXTLESSONLEVEL2: 'BÀI HỌC TIẾP THEO - CẤP ĐỘ 2',
NEXTLEVEL: 'CẤP ĐỘ TIẾP THEO',
ConversationInstruction: 'Lưu ý rằng trên trang học <img src="/Icons/study.svg" alt={translations[selectedLanguage].study} />, nửa đầu của câu tập trung vào thực hành nói, trong khi nửa sau tập trung vào nghe.',
NoVocabYet: 'No vocabularies added yet.'
  }
};

// Utility function to get the correct theme name based on the selected language
export const getThemeName = (theme, selectedLanguage) => {
  const languageMapping = {
    en: 'theme_name_en',
    es: 'theme_name_es',
    pt_br: 'theme_name_pt_br',
    ar: 'theme_name_ar',
    fa: 'theme_name_fa',
    zh: 'theme_name_zh',
    vi: 'theme_name_vi'
  };
  const themeKey = languageMapping[selectedLanguage] || 'theme_name_en';  
  // Return the theme name for the selected language or fallback to English
  return theme[themeKey] || theme.theme_name_en;
};

export const getTopicName = (topic, selectedLanguage) => {
  const languageMapping = {
    en: 'topic_name_en',
    es: 'topic_name_es',
    pt_br: 'topic_name_pt_br',
    ar: 'topic_name_ar',
    fa: 'topic_name_fa',
    zh: 'topic_name_zh',
    vi: 'topic_name_vi'
  };
  const topicKey = languageMapping[selectedLanguage] || 'topic_name_en';
  return topic[topicKey] || topic.topic_name_en;
};

export const getGroupName = (group, selectedLanguage) => {
  const languageMapping = {
    en: 'group_name_en',
    es: 'group_name_es',
    pt_br: 'group_name_pt_br',
    ar: 'group_name_ar',
    fa: 'group_name_fa',
    zh: 'group_name_zh',
    vi: 'group_name_vi'
  };
  const groupKey = languageMapping[selectedLanguage] || 'group_name_en';
  return group[groupKey] || group.group_name_en;
};

export const getInstruction = (content, selectedLanguage) => {
  const languageMapping = {
    en: 'instruction_en',
    es: 'instruction_es',
    pt_br: 'instruction_pt_br',
    ar: 'instruction_ar',
    fa: 'instruction_fa',
    zh: 'instruction_zh',
    vi: 'instruction_vi'
  };
  const instructionKey = languageMapping[selectedLanguage] || 'instruction_en';
  return content[instructionKey] || content.instruction_en;
};

export const getNote = (content, selectedLanguage) => {
  const languageMapping = {
    en: 'note_en',
    es: 'note_es',
    pt_br: 'note_pt_br',
    ar: 'note_ar',
    fa: 'note_fa',
    zh: 'note_zh',
    vi: 'note_vi'
  };
  const noteKey = languageMapping[selectedLanguage] || 'note_en';
  return content[noteKey] || content.note_en;
};

export const getTranslatedSentence = (content, selectedLanguage) => {
  if (selectedLanguage === '' && !content['en']) return '';
  if (!content || !content[selectedLanguage]) return '';
  return content[selectedLanguage] || content['en']; 
};


export const getInstructionVideo = (selectedLanguage) => {
  const videoMapping = {
    en: '/Video/short instruction video EN.mp4',
    es: '/Video/short instruction video ES.mp4',
    pt_br: '/Video/short instruction video PT_BR.mp4',
    ar: '/Video/short instruction video AR.mp4',
    fa: '/Video/short instruction video FA.mp4',
    zh: '/Video/short instruction video ZH.mp4',
    vi: '/Video/short instruction video VI.mp4'
  };
  const video = videoMapping[selectedLanguage] || '/Video/instruction video EN.mp4';  
  return video;
};

export const getPopupPosition = (ref, direction) => {
  if (!ref || !ref.current) {
    return { top: '0px', left: '0px' }; // Default position if ref is undefined
  } else {
    const rect = ref.current.getBoundingClientRect(); 
    let top = rect.bottom  + window.scrollY ;   
    if(direction === 'top'){
      top = rect.top ;
    }     
    let left = rect.left + 5;

    // Adjust if popup overflows right
    if (left + 200 > window.innerWidth) {
      left = window.innerWidth - 220;
    }

    // Adjust if popup overflows bottom
    if (top + 100 > window.innerHeight) {
      top = top - 150;
    }

    // Ensure the popup doesn't overflow out of the left side
    if (left < 10) {
      left = 10;
    }

    // Ensure the popup doesn't overflow out of the top side
    if (top < 10) {
      top = 10;
    }
    
    return {
      top: `${top}px`,
      left: `${left}px`,
    };
  } 
};